import { ca } from '@cian/analytics';
import { TProduct } from '../../types/product';

/**
 * Обновляет состояние products в @cian/analytics
 * @param { TProduct } products - Массив products, который хранится внутри @cian/analytics
 */
export const setTrackingProducts = (products: TProduct[]) => {
  ca('products', products);
};
